import getCSRFToken from './getCSRFToken';
import getCookie from './getCookie';
import setCookie from './setCookie';
import fetchRetry from './fetchRetry';

let apiToken;

const getCSRFCookie = () => {
	let csrfToken = null;
	const CSRFTokenFromCookie = getCookie('CSRFToken');

	if (CSRFTokenFromCookie) {
		csrfToken = CSRFTokenFromCookie;
	} else {
		csrfToken = getCSRFToken();
		setCookie('CSRFToken', csrfToken);
	}

	return csrfToken;
};

const getBearerToken = async (url = '') => {
	if (typeof apiToken !== 'undefined') {
		return apiToken;
	}

	let data = null;

	try {
		const response = await fetchRetry(
			`${url}/v3/oauth/tokenFromSession`,
			{
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-CSRF-TOKEN': getCSRFCookie()
				}
			}
		);

		data = await response.json();
		apiToken = data.result.payload[0].accessToken;
		return apiToken;
	} catch (e) {
		throw new Error(e);
	}
};

export default getBearerToken;



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/funcs/getBearerToken.js